<template>
  <div class="core h-full" v-show="loginFromShow">
    <div class="login-box">
      <div class="bg-white border login_block_out">
        <Form ref="loginModel" :model="loginModel" :rules="ruleValidate" label-position="top">
          <img class="login_logo" src="/images/logo.png" alt="">
          <!-- <div class="login_tit text-center mb-5 title">{{indexTitle}}</div> -->
          <FormItem prop="userName">
            <Input prefix="ios-person" size="large" v-model="loginModel.userName" placeholder="请输入用户名"></Input>
          </FormItem>
          <FormItem prop="password">
            <Input
              prefix="ios-lock"
              type="password"
              size="large"
              v-model="loginModel.password"
              placeholder="请输入密码"
              @keyup.enter.native="login('loginModel')"
            ></Input>
          </FormItem>
          <!-- <div class="logon_the_platform" @click="logonThePlatform">使用平台账号登陆</div> -->
          <FormItem>
            <Button
              :loading="loading"
              type="primary"
              class="basecolor"
              long
              size="large"
              shape="circle"
              @click="login('loginModel')"
            >登录</Button>
          </FormItem>
        </Form>
      </div>
    </div>
    <!-- <div class="login_bottom">
      备案号 浙ICP备20008887号-1 Copyright ©融御科技 版权所有
    </div> -->
    <Modal
      v-model="singleLoginShow"
      title="单点登录账号绑定"
      @on-ok="bindingLogin"
      @on-cancel="bindingLoginCancel"
      :loading="bindingLoginLoading"
      
      ok-text="绑定并登录">
        <div class="singleLog_tit">您的平台账户暂未绑定本系统，请输入系统账户密码进行绑定！</div>
        <Form ref="bindingLoginModel" :model="bindingForm" :rules="bindingRuleValidate" :label-width="80">
          <FormItem label="用户名" prop="userName">
            <Input v-model="bindingForm.userName" placeholder="请输入用户名"></Input>
          </FormItem>
          <FormItem label="密码" prop="password">
            <Input type="password" v-model="bindingForm.password" placeholder="请输入密码"></Input>
          </FormItem>
        </Form>
    </Modal>
  </div>
</template>
<script>
import userToken from '@/utils/token.js'
// import func from 'vue-editor-bridge';
export default {
  data() {
    const validatePass = (rule, value, callback) => {
      const regex = new RegExp('(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[^a-zA-Z0-9]).{8,16}')
      if (value === '') {
        callback(new Error('请输入新密码'))
      } else {
        // 密码中必须包含大小字母、数字、特称字符，至少8个字符，最多16个字符。
        if (!regex.test(value)) {
          callback(new Error('密码必须8至16位包含大小写字母、数字、特称字符'))
        }
        callback()
      }
    }
    return {
      loginFromShow:true,
      singleLoginShow: false,
      bindingForm: {
        userName:'',
        password:''
      },
      bindingLoginLoading:true,
      loading: false,
      loginModel: {
        userName: "",
        password: "",
      },
      vcodeSrc: "",
      ruleValidate: {
        userName: [
          { required: true, message: "用户名不能为空", trigger: "blur" },
        ],
        password: [
          { 
            required: true, 
            // validator: validatePass, 
            message: "密码不能为空",
            trigger: "blur" },
        ],
      },
      bindingRuleValidate: {
        userName: [
          { required: true, message: "用户名不能为空", trigger: "blur" },
        ],
        password: [
          { required: true, 
          // validator: validatePass, 
          message: "密码不能为空",
          trigger: "blur" },
        ],
      },
      // eslint-disable-next-line no-undef
      indexTitle: indexTitle
    };
  },
  watch:{
    $route(to,from){
      this.singleLoginRequest()
    }
  },
  created(){
    this.singleLoginRequest()
  },

  methods: {
    //登录
    login: function (name) {
      console.log(name)
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.loading = true;
          this.$store.dispatch("login", this.loginModel).then((rsp) => {
            this.loading = false;
            if (rsp != false) {
              window.sessionStorage.setItem('organCode',rsp.data.user.organCode||'')
              //定时刷新token
              setInterval((_) => {
                this.$store.dispatch("refreshToken");
              }, 1140 * 1000);
              this.$router.push({ path: "/" });
            }
            //this.getUserPremission();
          });
        }
      });
    },
    // 单点绑定登录
    bindingLogin () {
      this.bindingLoginLoading = true
      this.$refs.bindingLoginModel.validate((valid) => {
        if (valid) {
          this.$store.dispatch("login",{
            ...this.bindingForm,
            AuthID:this.AuthID,
            isBind:true
          }).then((rsp) => {
            if (rsp != false) {
              //定时刷新token
              setInterval((_) => {
                this.$store.dispatch("refreshToken");
              }, 1140 * 1000);
              this.$router.push({ path: "/" });
            }else{
              this.bindingLoginLoading = false;
              this.$nextTick(()=>this.bindingLoginLoading = true)
            }
            //this.getUserPremission();
          })
        }else{
          this.bindingLoginLoading = false
          this.$nextTick(()=>this.bindingLoginLoading = true)
        }
      })
    },
    bindingLoginCancel(){
      // eslint-disable-next-line no-undef
      window.location.href = `${rollbackUtl}/#/login`
    },
    //获取用户权限
    getUserPremission: function () {
      this.$api.get("/Role/getUserPremission", {}).then((rsp) => {
        if (rsp != false) {
          let result = rsp.data;
          localStorage.setItem("permissionCode", result);
          this.$router.push({ path: "/" });
        }
      });
    },
    logonThePlatform(){
      this.isauth=!this.isauth;
      let timeStamp=Date.parse(new Date());
      // eslint-disable-next-line no-undef
      window.location.href = authUri+"?redirect_uri="+rollbackUtl+"&app_id=cloudris&timestamp="+timeStamp+"&state=login";
      // eslint-disable-next-line no-undef
      // window.location.href = `${rollbackUtl}/#/singleLogin?open_id=61&open_user_name=阎秀兰&platform_id=13&app_id=15&app_user_name=郝静&timestamp=${Date.parse(new Date())}&ticket=Excepteur nostrud&signature=eiusmod eu`
    },
    singleLoginRequest(){
      let queryData = this.$route.query
      console.log(queryData)
      if(queryData.hasOwnProperty('open_id')&&queryData.hasOwnProperty('open_user_name')&&
        queryData.hasOwnProperty('platform_id')&&queryData.hasOwnProperty('app_id')&&queryData.hasOwnProperty('app_user_name')
        &&queryData.hasOwnProperty('timestamp')&&queryData.hasOwnProperty('ticket')&&queryData.hasOwnProperty('signature')) {
        this.loginFromShow=false
        this.$api.post(`/User/CheckUserContact`,{
          OpenID:queryData.open_id,
          OpenUserName:queryData.open_user_name,
          PlatformID:queryData.platform_id,
          AppID:queryData.app_id,
          AppUserName:queryData.app_user_name,
          TimeStamp:queryData.timestamp,
          Ticket:queryData.ticket,
          Signature:encodeURIComponent(queryData.signature)
        }).then(result=>{
          console.log(result)
          if(result.data){
            if(result.data.isNeedBindUser){
              this.AuthID=result.data.id
              this.singleLoginShow = true
            }else{
              if(result.data.access_token){
                this.$store.dispatch("bindingLogin",result.data).then((rsp) => {
                  if (rsp != false) {
                    //定时刷新token
                    setInterval((_) => {
                      this.$store.dispatch("refreshToken");
                    }, 1140 * 1000);
                    this.$router.push({ path: "/" });
                  }
                });
              }
            }
          }else{
            this.loginFromShow=true
          }
        })
      }
    }
  },
  components: {},
};
</script>
<style scoped lang="less">
.logon_the_platform{
  text-align: center;
  margin-bottom: 10px;
  position: relative;
  bottom: 5px;
  color: rgb(170, 164, 146);
  cursor: pointer;
}
.singleLog_tit{
  margin-bottom: 20px;
  text-align: center;
}
.login-box {
  width: 450px;
  margin-left: auto;
  margin-right: auto;
  padding-top: 20vh;
}
.basecolor {
  /* background-color: #bf0008; */
  border: none;
}
.title {
  font-weight: 600;
}
.vcode {
  width: 50px;
  height: 25px;
  position: absolute;
  top: 5px;
  left: 63%;
}
.hyz {
  cursor: pointer;
  margin-left: 80px;
}
.core {
  background: url("/images/loginbg.jpg") no-repeat;
  background-position: center 0;
  background-size: cover;
  position: relative;
  .login_bottom{
    position: absolute;
    bottom: 0;
    width: 100%;
    text-align: center;
    color: #fff;
    background: #333;
    padding: 10px 0;
    font-size: 12px;
  }
}
@keyframes scale-up-center {
  0%{
    transform: scale(.2);
  }
  100%{
    transform: scale(1);
  }
}
.login_block_out{
  border-radius: 30px;
  padding: 20px 50px;
  animation-name: scale-up-center;
  animation-duration: 0.5s;
  animation-timing-function: ease;
  animation-delay: 0s;
  animation-iteration-count: 1;
  animation-direction: normal;
  animation-fill-mode: none;
}
@keyframes slide-in-elliptic-bottom-fwd {
  0%{
    transform: translateY(600px) rotateX(30deg) scale(0);
    transform-origin: 50% 100%;
    opacity: 0;
  }
  100%{
    transform: translateY(0) rotateX(0) scale(1);
    transform-origin: 50% -1400px;
    opacity: 1;
  }
}
.login_logo{
  width: 190px;
  height: 60px;
  text-align: center;
  margin: 15px auto 25px;
  animation-name: slide-in-elliptic-bottom-fwd;
  animation-duration: 1s;
  animation-timing-function: ease;
  animation-delay: 0s;
  animation-iteration-count: 1;
  animation-direction: normal;
  animation-fill-mode: none;
}
@keyframes focus-in-contract {
  0%{
    letter-spacing: 1em;
    filter: blur(12px);
    opacity: 0;
  }
  100%{
    filter: blur(0);
    opacity: 1;
  }
}
.login_tit{
  color: #333;
  font-size: 22px;
  animation-name: focus-in-contract;
  animation-duration: 1s;
  animation-timing-function: ease;
  animation-delay: 0s;
  animation-iteration-count: 1;
  animation-direction: normal;
  animation-fill-mode: none;
}
/deep/.login_block_out .ivu-input{
  border-radius: 20px;
}
</style>